import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { DeliveryTracking } from "@/@types/Orders";
import { useTranslation } from "react-i18next";

interface ShipmentSelectorProps {
  trackings: DeliveryTracking[];
  value?: string;
  onChange: (trackingId: string) => void;
  error?: boolean;
}

export function ShipmentSelector({
  trackings,
  value,
  onChange,
  error,
}: ShipmentSelectorProps) {
  const { t } = useTranslation(["orders"]);

  if (trackings.length <= 1) {
    return null;
  }

  return (
    <div className="grid gap-2">
      <Label htmlFor="tracking_id">
        {t("orders:tracking.select_shipment")}
        <span className="text-destructive ml-1">*</span>
      </Label>
      <Select value={value || ""} onValueChange={onChange}>
        <SelectTrigger
          id="tracking_id"
          className={error ? "border-destructive" : ""}
        >
          <SelectValue
            placeholder={t("orders:tracking.select_shipment_placeholder")}
          />
        </SelectTrigger>
        <SelectContent position="popper">
          {trackings.map((tracking) => (
            <SelectItem
              key={tracking.id || tracking.provider}
              value={tracking.id || tracking.provider}
            >
              {[
                tracking.label,
                tracking.provider,
                tracking.processing_status_label || tracking.processing_status,
              ]
                .filter(Boolean)
                .join(" — ")}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {error && (
        <span className="text-xs text-destructive">
          {t("common:required_field")}
        </span>
      )}
    </div>
  );
}
